module.exports = __webpack_public_path__ + "static/media/personality-intro.0924ae8a.svg";